// extracted by mini-css-extract-plugin
export default {"container":"deal-overview-options-bar-component_container__uA0B0","truncate-table":"deal-overview-options-bar-component_truncate-table__1nreZ","table-text-faded":"deal-overview-options-bar-component_table-text-faded__PeiAu","wrapper":"deal-overview-options-bar-component_wrapper__dUh0Q","editSection":"deal-overview-options-bar-component_editSection__4eEi4"};
    if(module.hot) {
      // 1792500652986
      var cssReload = require("!../../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  